import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import Modal from '../mini/Modal'
import Button from '../mini/Buttons/Button'
import styled from 'styled-components'
import CloseIcon from '../../static/images/modal/close.svg'
import CloseIconHover from '../../static/images/modal/close_hover.svg'
import ReactTooltip from 'react-tooltip'
import P2 from '../typography/paragraphs/P2'
import { convertToRomanNumerals } from '../../utils/convertToRomanNumerals'
import { cleanHexCode } from '../mycourses/util'
import GradeElement from '../mini/GradeElement'

const ModalContainer = styled.div`
  width: 519px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background: ${colors.white};
  margin: 180px auto;
  padding-top: 40px;
`

const Header = styled.div`
  padding: 0 23px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-bottom: 23px;
`

const CourseName = styled.h3`
  color: ${props => props.color};
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  margin-left: 8px;
`

const MainContainer = styled.div`
  padding-bottom: 43px;
  border-bottom: 1px solid ${colors.ash};
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  text-align: center;
`

const DescriptionText = styled.h3`
  width: 419px;
  color: ${colors.black};
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 12px;
`

const ButtonBlock = styled.div`
  border-top: 1px solid ${colors.rock};
`

const OptionalBlock = styled.div`
  padding: 20px 25px;
  border-top: 1px solid ${colors.rock};
  display: flex;
  align-items: center;
  align-content: center;
  
  input, div {
    cursor: pointer;
  }
`

const CloseModal = ({
  activityCourse,
  gradeLevel,
  description,
  supportiveText,
  isOptionalTextExist,
  optionalText,
  deleteFunction
}) => {
  const dispatch = useDispatch()
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)
  const handleCheckboxChecked = () => {
    setIsCheckboxChecked(true)
  }

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  const deleteAndCloseTheModal = () => {
    deleteFunction()
    closeTheModal()
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowCloseOnExternalClick={false}
    >
      <ModalContainer closeCallback={closeTheModal}>
        {gradeLevel && activityCourse && (
          <Header>
            <GradeElement small
              data-for="gradeLevelNameTooltip"
              name={gradeLevel.name}
              abbreviation={gradeLevel.abbreviation}
            />
            <CourseName color={cleanHexCode(activityCourse.color)}>
              {isOptionalTextExist
                ? activityCourse.abbreviation +
                  ': ' +
                  convertToRomanNumerals(activityCourse.journeyIndex) +
                  ' ' +
                  activityCourse.journeyName
                : activityCourse.name}
            </CourseName>
          </Header>
        )}
        <MainContainer>
          <DescriptionText>{description}</DescriptionText>
          <p className="p2" style={{ marginBottom: '0' }}>
            {supportiveText}
          </p>
        </MainContainer>
        {isOptionalTextExist && (
          <OptionalBlock>
            <input
              type="checkbox"
              id="optional-text"
              name="optionalText"
              value="optionalText"
              style={{ marginRight: '15px' }}
              checked={isCheckboxChecked}
              onClick={handleCheckboxChecked}
            />
            <P2 onClick={handleCheckboxChecked}>{optionalText}</P2>
          </OptionalBlock>
        )}
        <ButtonBlock>
          <div
            style={{
              marginLeft: '46%',
              padding: '23px 23px 30px 0',
              display: 'flex'
            }}
          >
            <span style={{ marginRight: '20px' }}>
              <Button
                buttonColor={colors.white}
                width="104px"
                borderColor={colors.aluminum}
                title="Cancel"
                handleClick={closeTheModal}
                hoverBackground={colors.charcoal4}
                hoverColor={colors.white}
              />
            </span>
            <Button
              buttonColor={colors.white}
              width="129px"
              borderColor="#D23A3D"
              title="Delete"
              handleClick={deleteAndCloseTheModal}
              hoverBackground="#D23A3D"
              hoverColor={colors.white}
              shouldShowTooltipAndDisableButton={
                isOptionalTextExist && !isCheckboxChecked
              }
            />
          </div>
        </ButtonBlock>
      </ModalContainer>
    </Modal>
  )
}

CloseModal.propTypes = {
  activityCourse: PropTypes.object,
  gradeLevel: PropTypes.object,
  description: PropTypes.string.isRequired,
  supportiveText: PropTypes.string,
  isOptionalTextExist: PropTypes.bool,
  optionalText: PropTypes.string
}

export default CloseModal



// WEBPACK FOOTER //
// ./src/components/modal/CloseModal.js